export const URLS = {
  MTP_EMAIL: 'placement@meilleurtaux.com',
  KYC_URL: 'https://www.meilleurtaux.com/',
  MTP_URL: 'https://placement.meilleurtaux.com/',
  MTP_CONTACT_URL: 'https://placement.meilleurtaux.com/a-propos/comment-souscrire.html',
  MTP_URL_INVESTMENT: 'https://placement.meilleurtaux.com/placement-financier',
  PRIVATE_STOCK_EXCHANGE_URL: 'https://app.placement.meilleurtaux.com/user/login-bourse-privee',
  SURAVENIR_RENONCIATION_URL: 'https://espaceclient.suravenir.fr/web/suravenir/renonciation',
  ASSURANCE_VIE_URL: 'https://placement.meilleurtaux.com/assurance-vie/',
  PER_URL: 'https://placement.meilleurtaux.com/retraite/per/',
  LIVRET_EPARGNE_URL: 'https://placement.meilleurtaux.com/livret-epargne/super-livret/livret-meilleurtaux.html',
  DEFISCALISATION_URL: 'https://placement.meilleurtaux.com/placement-financier/defiscalisation/',
  SCPI_IMMOBILIER_URL: 'https://placement.meilleurtaux.com/scpi/',
  BOURSE_URL: 'https://placement.meilleurtaux.com/bourse/',
  YOUTUBE_NOCOOKIE_EMBED_URL: 'https://www.youtube-nocookie.com/embed/',
  YOUTUBE_IFRAME_API_URL: 'https://www.youtube.com/iframe_api',
};
